import React from "react"; // Removed useState import since it's no longer needed
import styles from "./MentorshipPage.module.css";

const MentorshipPage = () => {
  // Removed unused activeTab state

  // Topmate links for different session durations
  const topmateLinks = {
    "20mins": "https://topmate.io/exademy_education/1960336", // Replace with actual link
    "40mins": "https://topmate.io/mentor/40min-session", // Replace with actual link
    "1hour": "https://topmate.io/mentor/1hour-session", // Replace with actual link
    "1.5hour": "https://topmate.io/mentor/1.5hour-session" // Replace with actual link
  };

  // Mentorship programs data
  const mentorshipPrograms = [
    {
      id: 1,
      duration: "20 Minutes",
      durationValue: "20mins",
      title: "Quick Consultation",
      description: "Perfect for doubt clearing, quick guidance, or specific problem-solving",
      price: "₹499",
      originalPrice: "₹999",
      discount: "50% off",
      features: [
        "One specific topic discussion",
        "Doubt clearing session",
        "Quick strategy review",
        "Available 24/7"
      ],
      icon: "fas fa-clock",
      color: "#0B5E42",
      availability: "Instant Booking",
      suitable: "Ideal for: Quick doubts, 1-2 questions"
    },
    {
      id: 2,
      duration: "40 Minutes",
      durationValue: "40mins",
      title: "In-Depth Discussion",
      description: "Comprehensive session for detailed topic coverage and strategy planning",
      price: "₹899",
      originalPrice: "₹1,799",
      discount: "50% off",
      features: [
        "Detailed topic discussion",
        "Previous year question analysis",
        "Preparation strategy review",
        "Study plan discussion"
      ],
      icon: "fas fa-hourglass-half",
      color: "#8B5CF6",
      availability: "Next Day Available",
      suitable: "Ideal for: Topic deep-dive, strategy planning"
    },
    {
      id: 3,
      duration: "1 Hour",
      durationValue: "1hour",
      title: "Comprehensive Mentorship",
      description: "Extended session for complete syllabus discussion and doubt resolution",
      price: "₹1,499",
      originalPrice: "₹2,999",
      discount: "50% off",
      features: [
        "Complete chapter discussion",
        "Mock test review",
        "Answer writing practice",
        "Personalized study plan"
      ],
      icon: "fas fa-hourglass-end",
      color: "#2563EB",
      availability: "Schedule in Advance",
      suitable: "Ideal for: Complete chapter coverage, test review"
    },
    {
      id: 4,
      duration: "1.5 Hour",
      durationValue: "1.5hour",
      title: "Premium Mentorship",
      description: "Extended premium session for in-depth mentorship and guidance",
      price: "₹2,199",
      originalPrice: "₹4,399",
      discount: "50% off",
      features: [
        "Complete syllabus review",
        "Multiple topics coverage",
        "Detailed feedback session",
        "Customized preparation roadmap"
      ],
      icon: "fas fa-star",
      color: "#DC2626",
      availability: "Prior Booking Required",
      suitable: "Ideal for: Comprehensive review, mentorship"
    }
  ];

  // Handle booking redirect
  const handleBookNow = (durationValue) => {
    window.open(topmateLinks[durationValue], "_blank");
  };

  return (
    <main className={styles.mentorshipPage}>
      {/* Hero Section - Simplified */}
      <section className={styles.heroSection}>
        <div className={styles.container}>
          <div className={styles.heroContent}>
            <h1 className={styles.heroTitle}>
              Book <span className={styles.gradientText}>1:1 Mentorship</span> with IITian Faculty
            </h1>
            <p className={styles.heroSubtitle}>
              Get personalized guidance, clear your doubts, and accelerate your preparation with our expert mentors.
            </p>
          </div>
        </div>
        
        {/* Background decoration */}
        <div className={styles.heroDecoration}>
          <div className={styles.circle1}></div>
          <div className={styles.circle2}></div>
        </div>
      </section>

      {/* How It Works Section - Simplified to 3 steps */}
      <section className={styles.howItWorks}>
        <div className={styles.container}>
          <div className={styles.sectionHeaderCenter}>
            <h2>How It <span className={styles.gradientText}>Works</span></h2>
          </div>

          <div className={styles.stepsGrid}>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>1</div>
              <div className={styles.stepIcon}>
                <i className="fas fa-calendar-check"></i>
              </div>
              <h3>Choose Duration</h3>
              <p>Select from 20min to 1.5hr sessions based on your needs</p>
            </div>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>2</div>
              <div className={styles.stepIcon}>
                <i className="fas fa-clock"></i>
              </div>
              <h3>Book Slot</h3>
              <p>Select your preferred time and complete payment on Topmate</p>
            </div>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>3</div>
              <div className={styles.stepIcon}>
                <i className="fas fa-video"></i>
              </div>
              <h3>Join Session</h3>
              <p>Get meeting link and have your 1:1 mentorship session</p>
            </div>
          </div>
        </div>
      </section>

      {/* Mentorship Programs Grid */}
      <section className={styles.programsSection}>
        <div className={styles.container}>
          <div className={styles.programsGrid}>
            {mentorshipPrograms.map((program) => (
              <div key={program.id} className={styles.programCard}>
                <div className={styles.programCardHeader} style={{ background: `linear-gradient(145deg, ${program.color}15, ${program.color}05)` }}>
                  <div className={styles.programDuration}>
                    <i className="fas fa-hourglass-start"></i>
                    <span>{program.duration}</span>
                  </div>
                  <div className={styles.programDiscount}>{program.discount}</div>
                </div>
                
                <div className={styles.programCardBody}>
                  <div className={styles.programIconWrapper} style={{ background: program.color }}>
                    <i className={program.icon}></i>
                  </div>
                  <h3>{program.title}</h3>
                  <p className={styles.programDescription}>{program.description}</p>
                  
                  <div className={styles.programFeatures}>
                    {program.features.map((feature, idx) => (
                      <div key={idx} className={styles.featureItem}>
                        <i className="fas fa-check-circle" style={{ color: program.color }}></i>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>

                  <div className={styles.availabilityBadge}>
                    <i className="fas fa-calendar-alt"></i>
                    <span>{program.availability}</span>
                  </div>

                  <div className={styles.suitableFor}>
                    <i className="fas fa-bullseye"></i>
                    <span>{program.suitable}</span>
                  </div>
                </div>

                <div className={styles.programCardFooter}>
                  <div className={styles.priceSection}>
                    <span className={styles.originalPrice}>{program.originalPrice}</span>
                    <span className={styles.currentPrice}>{program.price}</span>
                    <span className={styles.priceLabel}>/session</span>
                  </div>
                  <button 
                    className={styles.bookNowBtn}
                    onClick={() => handleBookNow(program.durationValue)}
                    style={{ background: program.color }}
                  >
                    Book Now
                    <i className="fas fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default MentorshipPage;